import axios from "axios"
import { env } from "../constants"

export const list = (token, kind = "received") => {
    const uri = `${env.startpoint}certificates`
    const headers = { headers: { Authorization: `Bearer ${token}` }, params: { kind } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const create = (token, data) => {
    const uri = `${env.startpoint}certificates`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(error => error.response)
}

export const get = (token, code) => {
    const uri = `${env.startpoint}certificates/${code}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const redeem = (token, code) => {
    const uri = `${env.startpoint}certificates/${code}/redeem`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, {}, headers).then(response => response).catch(error => error.response)
}
